import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FixedDataPicker } from '../fixed-data-picker/FixedDataPicker';
import { IPickerProps } from '../types';

export enum ProjectStepLinkDirection {
  Incoming = 'Incoming',
  Outgoing = 'Outgoing',
}

export type ProjectStepLinkDirectionPickerProps<TMultiple extends boolean> =
  IPickerProps<{ id: ProjectStepLinkDirection; name: string }, TMultiple>;

export function ProjectStepLinkDirectionPicker<TMultiple extends boolean>(
  props: ProjectStepLinkDirectionPickerProps<TMultiple>
) {
  const { t } = useTranslation();
  const data = useMemo(() => {
    return Object.keys(ProjectStepLinkDirection)
      .map((key) => {
        const id = ProjectStepLinkDirection[key];

        return {
          id,
          name: t(`PROJECT_STEP_LINK_DIRECTION.${id}`),
        };
      })
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [t]);

  return <FixedDataPicker dataSet={data} {...props} />;
}
